type LoginEventPayloadType = {
  email?: string | null;
  phone?: string | null;
  user_id: string;
};

const pushToDataLayer = (eventName: string, payload: Record<string, any> = {}) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};

const _buildAuthPayload = ({ email, phone, user_id }: LoginEventPayloadType) => ({
  user_id,
  ...(email ? { email } : {}),
  ...(phone ? { phone } : {}),
});

const pushLoginEvent = (payload: LoginEventPayloadType) => {
  pushToDataLayer('login', _buildAuthPayload(payload));
};

const pushSignUpEvent = (payload: LoginEventPayloadType) => {
  pushToDataLayer('sign_up', _buildAuthPayload(payload));
};

const pushSessionStartEvent = (payload: LoginEventPayloadType) => {
  pushToDataLayer('session_start', _buildAuthPayload(payload));
};

export { pushToDataLayer, pushLoginEvent, pushSignUpEvent, pushSessionStartEvent };
